/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./node-item.vue?vue&type=template&id=51c4fb69&scoped=true&"
import script from "./node-item.vue?vue&type=script&lang=js&"
export * from "./node-item.vue?vue&type=script&lang=js&"
import style0 from "./node-item.vue?vue&type=style&index=0&id=51c4fb69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c4fb69",
  null
  
)

export default component.exports